import { ref, uploadBytesResumable, getDownloadURL, storage } from '@core/firebase';
import { useState } from 'react';
import { toast } from 'react-hot-toast';

/**
 * useStorage Hook - Simple interface for Firebase Storage.
 */
export const useStorage = () => {
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);

    const uploadImage = async (file, path) => {
        if (!file) return null;
        
        setUploading(true);
        setProgress(0);

        try {
            const storageRef = ref(storage, path);
            const uploadTask = uploadBytesResumable(storageRef, file);

            return new Promise((resolve, reject) => {
                uploadTask.on('state_changed', 
                    (snapshot) => {
                        const p = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        setProgress(p);
                    }, 
                    (error) => {
                        toast.error("Upload failed");
                        setUploading(false);
                        reject(error);
                    }, 
                    async () => {
                        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                        setUploading(false);
                        resolve(downloadURL);
                    }
                );
            });
        } catch (error) {
            setUploading(false);
            throw error;
        }
    };

    return { uploadImage, uploading, progress };
};
